import React, { useMemo, useState } from "react";
import { Button, Divider, Modal, Typography, Segmented } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import {
  howToStartAiAssessmentVideoChrome,
  howToStartAiAssessmentVideoChromeManual,
  howToStartAiAssessmentPdfChrome,
  howToStartAiAssessmentPdfChromeManual,
} from "../../../../Utils/constants";
import "./aiAssessmentHelpModal.scss";

interface AIAssessmentHelpModalProps {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const AIAssessmentHelpModal: React.FC<AIAssessmentHelpModalProps> = ({
  isOpen,
  setIsOpen,
}) => {
  const [mode, setMode] = useState<"default" | "manual">("default");

  const pdfUrl = useMemo(
    () =>
      mode === "default"
        ? howToStartAiAssessmentPdfChrome
        : howToStartAiAssessmentPdfChromeManual,
    [mode]
  );

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <Modal
      open={isOpen}
      onCancel={handleClose}
      footer={null}
      title={null}
      centered
      destroyOnClose
      closeIcon={false}
      width={800}
    >
      <section className="ai-assessment-help-modal-content">
        <div className="ai-assessment-help-modal-content-header">
          <Typography.Title level={4} style={{ margin: 0 }}>
            How to start AI Assessment
          </Typography.Title>

          <Segmented
            name="mode"
            shape="round"
            options={[
              { value: "default", label: "Default" },
              { value: "manual", label: "Manual" },
            ]}
            onChange={setMode}
          />
        </div>

        <Divider style={{ margin: "0" }} />

        <div className="ai-assessment-help-modal-video-container">
          <video
            key={mode}
            width="100%"
            height="auto"
            autoPlay
            loop
            muted
            controls
            style={{
              borderRadius: "8px",
            }}
          >
            <source
              src={
                mode === "default"
                  ? howToStartAiAssessmentVideoChrome
                  : howToStartAiAssessmentVideoChromeManual
              }
              type="video/mp4"
            />
            Your browser does not support the video tag.
          </video>
        </div>

        <Divider style={{ margin: "0" }} />

        <div className="ai-assessment-help-modal-content-footer">
          <Typography.Text>
            Want to view it as a PDF? {""}
            <Typography.Link
              href={pdfUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              Click here.
            </Typography.Link>
          </Typography.Text>
          <Button type="default" onClick={handleClose} icon={<CloseOutlined />}>
            Close
          </Button>
        </div>
      </section>
    </Modal>
  );
};

export default AIAssessmentHelpModal;
